import {
  AfterViewInit,
  Component,
  ElementRef,
  Inject,
  ViewChild,
} from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "dialog-content",
  templateUrl: "./epacak-dialouge.component.html",
})
export class EpackEolDialogComponent implements AfterViewInit {
  @ViewChild("dialougeHeader") dialougeHeader!: ElementRef<HTMLDivElement>;
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      content: string;
      headerData: {
        "Test ID": string;
        "Test Date": string;
        "Pack ID": string;
        "BMS ID": string;
        "Hardware Version": string;
        Variant: string;
        Product: string;
      };
    },
    public dialogRef: MatDialogRef<EpackEolDialogComponent>
  ) {}

  ngAfterViewInit(): void {
    Object.entries(this.data.headerData).forEach(([key, value]) => {
      const paragraph = document.createElement("p");
      const itemKey = document.createElement("b");
      const itemValue = document.createTextNode(`: ${value}`);

      itemKey.innerText = key;

      paragraph.appendChild(itemKey);
      paragraph.appendChild(itemValue);

      paragraph.style.marginBottom = "2px";

      this.dialougeHeader.nativeElement.appendChild(paragraph);
    });
  }
  closeDailoge(): void {
    this.dialogRef.close();
  }
}
